import * as Actions from '../actions';

const initialState = {
    contentLabelList: []
}

const contentLabelReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_CONTENT_LABEL_LIST):
            {
                return {
                    ...state,
                    contentLabelList: action.payload
                }
            }
        default:
            {
                return state;
            }
    }
}

export default contentLabelReducer;


// WEBPACK FOOTER //
// src/main/content/content_label/store/reducers/content_lable.reducer.js